<template>
  <div class="w-100">
    <div class="mb-5" v-if="isSearchShown && getMerchant.additional_appearance === 'SEARCH_ROOM'">
      <HotelProductTab />
    </div>

    <div class="w-100 mb-5" v-if="isSearchShown">
      <HotelRoomFilter @search="loadRoomList" />
    </div>

    <div v-if="isResultFilterShown" class="w-100 d-flex align-items-center justify-content-end mb-3" :class="{ 'justify-content-lg-between': isTotalRoomOfferShown }">
      <p class="d-none d-lg-block heading-6-1 mb-0 ls-0-15" v-if="isTotalRoomOfferShown">{{ totalRoomResult }}</p>
      <div class="d-flex align-items-center flex-wrap flex-md-nowrap">
        <div v-if="$isNotEmptyV2(getBeFilterDetail.data)" class="px-2-5 py-2 d-flex align-items-center border-form rounded mr-2-5 mb-2 mb-md-0 order-2 order-md-0">
          <p class="mb-0 body-2-4 mr-2-5"><span class="text-subcolor body-2-1">Show only:</span> {{ getBeFilterDetail.data.name }}</p>
          
          <svg class="cursor-pointer" @click="clearFilterDetail" width="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.8 6.21L17.39 4.8L11.8 10.39L6.21 4.8L4.8 6.21L10.39 11.8L4.8 17.39L6.21 18.8L11.8 13.21L17.39 18.8L18.8 17.39L13.21 11.8L18.8 6.21Z" fill="#222222"/>
          </svg>      
        </div>
        <div class="mr-2-5 z-index-1021 mb-2 mb-md-0 order-0 order-md-1">
          <HotelRoomFilterPrice @apply="loadRoomList" />
        </div>
        <div class="order-1 order-md-2 mb-2 mb-md-0">
          <HotelRoomFilterGroupBy @select="loadRoomList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import HotelProductTab from '@/components/hotel/HotelProductTab.vue';
  import HotelRoomFilter from '@/components/hotel/be/HotelRoomFilter.vue';
  import HotelRoomFilterGroupBy from '@/components/hotel/be/HotelRoomFilterGroupBy.vue';
  import HotelRoomFilterPrice from '@/components/hotel/be/HotelRoomFilterPrice.vue';

  const FILTER_SECTION = { ALL: 'all', SEARCH: 'search', RESULT: 'result' };

  export default {
    props:{
      totalRoomResult:{
        type: String,
        default: ''
      },
      // mobile renders the search box and the result filters apart so Special Offers can sit between them
      section:{
        type: String,
        default: FILTER_SECTION.ALL
      }
    },
    components:{
      HotelProductTab,
      HotelRoomFilter, 
      HotelRoomFilterGroupBy,
      HotelRoomFilterPrice
    },
    computed:{
      ...mapGetters(['getMerchant', 'getBeFilterDetail']),
      // Merchant lama belum punya field ini, jadi ringkasan jumlah offer tetap tampil
      isTotalRoomOfferShown(){
        return this.getMerchant.search_room_is_show_total_room_offers !== false
      },
      isSearchShown(){
        return this.section !== FILTER_SECTION.RESULT
      },
      isResultFilterShown(){
        return this.section !== FILTER_SECTION.SEARCH
      }
    },
    methods: {
      ...mapMutations(['setBeFilterDetail']),
      loadRoomList() {
        this.$emit('loadRoomList');
      },
      clearFilterDetail(){
        this.setBeFilterDetail({type: 'room_type', data: {}})
        this.loadRoomList()
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/HotelRoomFilterGeneral.vue